<template>
  <div class="placing-success-root">
    <div class="placingSuccessfullyPage">
      <div class="orderDetailBox">
        <div class="confirmation">
          <h1 class="confirmationH1">
            <div class="icon">
              <div class="green">
                <img :src="require('@/assets/icon/gougou.svg')" alt="" />
              </div>
            </div>
            <!-- 报价正在处理中 -->
            {{ $fanyi("报价正在处理中") }}
          </h1>

          <!-- 感谢您的垂询。我们已收到您的请求，正在处理中。您将在24小时内收到报价。您还将收到不同物流方式的报价。 -->
          <p>
            {{
              $fanyi(
                "感谢您的垂询。我们已收到您的请求，正在处理中。您将在24小时内收到报价。您还将收到不同物流方式的报价。"
              )
            }}
          </p>

          <el-button
            class="uiBtn uiGreen confirmation__btn"
            @click="$fun.routerToPage('/user/index')"
            >{{ $fanyi("控制面板") }}</el-button
          >
        </div>
        <div class="alertaDeInformaci">
          <img
            src="https://rakumart-test.oss-cn-hangzhou.aliyuncs.com/20260701152911831330.118d6ae9%5B1%5D"
            alt=""
          />
          <!-- 可用的运输方式取决于您的订单详情（尺寸、产品净重等）。 -->
          <p>
            {{
              $fanyi(
                "可用的运输方式取决于您的订单详情（尺寸、产品净重等）。"
              )
            }}
          </p>
        </div>
        <div class="goodsBox" :class="{ GoodsArrAll: showGoodsArrAll }">
          <h1 @click="getBuyGoodsArr">
            {{ $fanyi("订单摘要") }}
            <span class="goodsBoxtishi"
              >{{ $fanyi("订单号") }}:{{ $parent.datas.order_sn }}</span
            >
          </h1>

          <div class="goodsArr">
            <div class="goodsHead goodsTr">
              <div class="goodsTd goodshe goodsName"></div>
              <div class="goodsTd goodshe goodsNumber">
                {{ $fanyi("购买金额") }}
              </div>
              <!-- 产品总价 -->
              <div class="goodsTd goodshe goodsPrice">
                {{ $fanyi("产品总价") }}
              </div>
            </div>
            <div
              class="goodsOpt goodsTr"
              v-for="goodsItem in buyGoodsArr"
              :key="'good' + goodsItem.id"
            >
              <div class="goodsTd goodsBo goodsName">
                <el-popover placement="right" trigger="hover">
                  <img
                    :src="goodsItem.pic"
                    alt=""
                    style="width: 300px; height: 300px"
                  />

                  <el-image slot="reference" :src="goodsItem.pic">
                    <div slot="error" class="image-slot">
                      <i class="el-icon-picture-outline"></i>
                    </div>
                    <div slot="placeholder">
                      <i class="el-icon-loading"></i>
                    </div>
                  </el-image>
                </el-popover>
                <el-popover placement="bottom" trigger="hover" width="800">
                  {{ goodsItem.goods_title }}
                  <span slot="reference" class="goodsTitle">
                    {{ goodsItem.goods_title }}
                  </span>
                </el-popover>
              </div>
              <div class="goodsTd goodsBo goodsNumber">
                {{ goodsItem.num }}
              </div>
              <div class="goodsTd goodsBo goodsPrice">
                <p>
                  {{
                    $fun.RMBNumSegmentation(
                      $fun.ceil(
                        goodsItem.num *
                          goodsItem.price *
                          $parent.datas.exchange_rate
                      )
                    )
                  }}€
                </p>
                <p>
                  ({{
                    $fun.RMBNumSegmentation(
                      $fun.ceil(goodsItem.num * goodsItem.price)
                    )
                  }}￥)
                </p>
              </div>
              <div class="henXian"></div>
            </div>
          </div>
          <div class="showAllRow">
            <img
              class="jiahao"
              src="../../../../../../assets/icon/jiahao_fill.svg"
              alt=""
              @click="showGoodsArrAll = !showGoodsArrAll"
              v-if="!showGoodsArrAll"
            />
            <img
              class="jiahao jian"
              src="../../../../../../assets/icon/jianhao.svg"
              alt=""
              @click="showGoodsArrAll = !showGoodsArrAll"
              v-else
            />
          </div>
        </div>
      </div>

      <div class="ortherBox">
        <div class="operatingPrinciple">
          <!-- 下一步： -->
          <h1 class="operatingPrincipletishi">{{ $fanyi("下一步：") }}</h1>
          <div>
            <div class="tishiOpt">
              <div class="tihsiNum">1</div>
              <div class="tishiCon">
                <h1>{{ $fanyi("我们联系制造商") }}</h1>
                <!-- 我们将联系供应商以获取必要信息及订单报价。 -->
                <div>
                  {{
                    $fanyi(
                      "我们将联系供应商以获取必要信息及订单报价。"
                    )
                  }}
                </div>
              </div>
            </div>
            <div class="tishiOpt">
              <div class="tihsiNum">2</div>
              <div class="tishiCon">
                <!-- 我们将在24小时内为您报价 -->
                <h1>{{ $fanyi("我们将在24小时内为您报价") }}</h1>
                <!-- 我们将通知您各种运输方式（空运、海运、陆运）的预估费用。 -->
                <div>
                  {{
                    $fanyi(
                      "我们将通知您各种运输方式（空运、海运、陆运）的预估费用。"
                    )
                  }}
                </div>
              </div>
            </div>
            <div class="tishiOpt">
              <div class="tihsiNum">3</div>
              <div class="tishiCon">
                <h1>{{ $fanyi("订单付款") }}</h1>
                <!-- 报价生成后，您可通过银行转账或信用卡支付完成订单。 -->
                <div>
                  {{
                    $fanyi(
                      "报价生成后，您可通过银行转账或信用卡支付完成订单。"
                    )
                  }}
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="contactUs">
          <!-- 有疑问？ -->
          <h1>{{ $fanyi("有疑问？") }}</h1>
          <p @click="tohref">
            <img src="../../../../../../assets/icon/xinFen2.png" alt="" />
            <!-- 邮箱: service@rakumart.it -->
            <span
              >{{ $fanyi("邮箱:") }}
              <font class="blueFont">service@rakumart.it</font>
            </span>
            <img
              class="jiantou"
              src="../../../../../../assets/icon/jisntou2.png"
              alt=""
            />
          </p>
          <p @click="$fun.clickJs()">
            <img src="../../../../../../assets/icon/xiaoxi2.png" alt="" />
            <!-- 使用rakuchat联系我们 -->
            <span>{{ $fanyi("使用rakuchat联系我们") }}</span>
            <img
              class="jiantou"
              src="../../../../../../assets/icon/jisntou2.png"
              alt=""
            />
          </p>
          <p
            @click="
              $fun.routerToPage(
                'https://api.whatsapp.com/send/?phone=393762669726',
                true
              )
            "
          >
            <img src="@/assets/icon/dianhua2.png" alt="" />
            <!-- 通过WhatsApp联系我们 -->
            <span>{{ $fanyi("通过WhatsApp联系我们") }} </span>
            <img
              class="jiantou"
              src="../../../../../../assets/icon/jisntou2.png"
              alt=""
            />
          </p>
        </div>
      </div>
    </div>
    <div class="recommendGoodsMain">
      <nav>
        <!-- 推荐给您的商品 -->
        <h4>{{ $fanyi("推荐给您的商品") }}</h4>
        <div class="iconBox">
          <img
            src="../../../../../../assets/icon/flecha-izquierda.svg"
            alt=""
            @click="shopCarouselChange('left')"
          />
          <img
            src="../../../../../../assets/icon/flecha-izquierda-1.svg"
            alt=""
            @click="shopCarouselChange('right')"
          />
        </div>
      </nav>
      <div>
        <el-carousel
          trigger="click"
          ref="shopCarousel"
          :interval="3000"
          :autoplay="autoplay"
          @mouseover.native="autoplay = false"
          @mouseleave.native="autoplay = true"
        >
          <el-carousel-item
            v-for="(item, index) in goodsList"
            :key="index"
            v-show="item.status"
          >
            <div class="recommendGoodsBox">
              <div
                v-for="(goodsItem, goodsIndex) in item"
                :key="goodsIndex"
                class="recommendGoods"
                @click="$fun.toCommodityDetails(goodsItem.goods_id, goodsItem)"
              >
                <div class="imageBox">
                  <el-image :src="goodsItem.imgUrl">
                    <div slot="error" class="image-slot">
                      <i class="el-icon-picture-outline"></i>
                    </div>
                    <div slot="placeholder">
                      <i class="el-icon-loading"></i>
                    </div>
                  </el-image>
                </div>
                <div class="goodsTitle" :title="goodsItem.title">
                  {{ goodsItem.title }}
                </div>
                <div class="priceBox">
                  <span class="priceBox">
                    <span>
                      {{
                        $fun.EURNumSegmentation(
                          $fun.ceil(
                            goodsItem.goodsPrice * $store.state.exchangeRate
                          )
                        )
                      }}€ </span
                    ><span>
                      {{ $fun.RMBNumSegmentation(goodsItem.goodsPrice) }}￥
                    </span>
                  </span>
                </div>
              </div>
            </div>
          </el-carousel-item>
        </el-carousel>
      </div>
    </div>
    <FootVue></FootVue>
  </div>
</template>
<script>
import whyDiaVue from "./whyDia.vue";
import FootVue from "../../../../../../components/foot/Foot.vue";
export default {
  data() {
    return {
      buyGoodsArr: [],
      showGoodsArrAll: false,
      goodsList: [],
      autoplay: true,
      translation_name: "",
      chinese_name: "",
    };
  },
  components: { whyDiaVue, FootVue },
  computed: {},
  created() {
    this.getBuyGoodsArr();
    this.getPersonalizedGoods();
  },
  methods: {
    tohref() {
      location.href = "mailto:service@rakumart.it";
    },

    //打开为什么装运是估计的弹窗
    openWhyDia() {
      this.$refs.whyDia.open();
    },
    // 获取推荐商品数据
    getPersonalizedGoods() {
      this.$api.getPersonalizedGoods().then((res) => {
        this.goodsList = res.data.result;
        this.chinese_name = res.data.chinese_name;
        this.translation_name = res.data.translation_name;
        this.ProcessingShopData();
      });
    },
    // 数据处理
    ProcessingShopData() {
      //console.log(23);
      let lack = 6 - (this.goodsList.length % 6); //取得店铺商品数离6个的倍数差多少个商品的数量
      //console.log("缺多少个商品", lack);
      //差多少个就从最前面取多少个填充到最后
      for (let i = 0; i < lack; i++) {
        this.goodsList.push(this.goodsList[i]);
      }
      //  分成六个一组
      this.goodsList = this.$fun.changeArr(this.goodsList, 6);
      //console.log(this.goodsList);
      this.$forceUpdate();
    },
    // 滑动店铺商品列表
    shopCarouselChange(type) {
      if (type == "left") {
        this.$refs.shopCarousel.prev();
      } else if (type == "right") {
        this.$refs.shopCarousel.next();
      }
    },
    getBuyGoodsArr() {
      //console.log(this.$parent.newList);
      let buydata = [];
      this.$parent.newList.forEach((shopsItem) => {
        shopsItem.list.forEach((goodsItem) => {
          buydata.push(goodsItem);
        });
      });
      this.buyGoodsArr = buydata;
    },
  },
};
</script>
<style lang="scss" scoped="scoped">
@import "@/css/mixin";

.placing-success-root {
  background: #fafafa;
  min-width: 0;
}

.placingSuccessfullyPage {
  display: flex;
  align-items: flex-start;
  width: 100%;
  max-width: $pageWidth;
  margin: 0 auto;
  padding: 24px 16px 40px;
  box-sizing: border-box;

  .orderDetailBox {
    .confirmation {
      width: 760px;
      max-width: 100%;
      background: #ffffff;
      border: 1px solid #eaecf0;
      border-radius: 12px;
      padding: 40px 48px 28px;
      margin-bottom: 20px;
      box-sizing: border-box;
      box-shadow: 0 1px 3px rgba(16, 24, 40, 0.06);

      .confirmationH1 {
        text-align: center;
        font-size: 20px;
        line-height: 1.3;
        font-weight: 600;
        color: #101828;
        margin-bottom: 23px;

        .icon {
          width: 100px;
          height: 100px;
          background: #eaf8e8;
          border-radius: 50%;
          display: flex;
          margin: 0 auto 24px;
          justify-content: center;
          align-items: center;

          .green {
            display: flex;
            justify-content: center;
            align-items: center;
            width: 48px;
            height: 48px;
            background: #009246;
            border-radius: 50%;

            img {
              width: 28px;
              height: 22px;
            }
          }
        }
      }

      p {
        max-width: 582px;
        font-size: 16px;
        font-weight: 400;
        color: #475467;
        line-height: 26px;
        margin: 0 auto 24px;
        text-align: center;
      }

      .confirmation__btn {
        @extend .dip;
        margin: 8px auto 0;
        min-width: 240px;
        height: 48px;
        border-radius: 10px;
        font-size: 16px;
        font-weight: 600;
      }
    }

    .alertaDeInformaci {
      width: 760px;
      max-width: 100%;
      background: #fffbeb;
      border: 1px solid #fcd34d;
      border-radius: 12px;
      padding: 32px 24px;
      text-align: center;
      margin-bottom: 20px;
      box-sizing: border-box;

      img {
        width: 44px;
        height: 44px;
        margin-bottom: 16px;
      }

      p {
        max-width: 640px;
        margin: 0 auto;
        font-size: 15px;
        line-height: 24px;
        color: #92400e;
      }
    }

    .goodsBox {
      width: 760px;
      max-width: 100%;
      max-height: 288px;
      background: #ffffff;
      border: 1px solid #eaecf0;
      border-radius: 12px;
      padding: 24px 0 0;
      position: relative;
      transition: 0.3s;
      overflow: hidden;
      box-shadow: 0 1px 3px rgba(16, 24, 40, 0.06);

      .buyOrderSn {
        height: 38px;
        display: flex;
        justify-content: space-between;
        align-items: center;

        b {
          font-size: 16px;
          font-weight: 600;
        }
      }

      &.marginhave {
        margin-left: -40px;
        margin-top: -20px;
        margin-bottom: -20px;
        padding-top: 0;
        border: none;
        height: 222px;
        min-height: 222px;
      }

      h1 {
        padding: 0 32px;
        margin-bottom: 16px;
        font-size: 18px;
        font-weight: 600;
        color: #101828;
        line-height: 28px;
        display: flex;
        justify-content: space-between;
        align-items: center;

        .goodsBoxtishi {
          font-size: 14px;
          font-weight: 500;
          color: #475467;
          line-height: 20px;
        }
      }

      .goodsArr {
        padding: 0 32px;

        .goodsTr {
          display: flex;
          align-items: center;

          // 循环的商品行
          &.goodsOpt {
            position: relative;
            padding: 8px 0 12px;

            .henXian {
              width: 100%;
              height: 4px;
              background: #eaecf0;
              border-radius: 4px;
              position: absolute;
              left: 0;
              bottom: 0;
            }
          }

          // 所有单元格样式
          .goodsTd {
            font-size: 13px;
            font-weight: 400;
            color: #344054;
            line-height: 29px;
            flex: 1;

            // 所有单元格标题样式
            &.goodshe {
              margin-top: 12px;
              font-size: 12px;
              line-height: 1;
              font-weight: 600;
              color: #667085;
              background-color: transparent;
              display: flex;
              align-items: flex-end;
            }

            // 所有单元格内容样式
            &.goodsBo {
              height: 55px;
            }

            // 单个单元格样式》》》
            // 价格单元格样式
            &.goodsPrice {
              flex: 0 0 164px;
              margin-left: 50px;

              &.goodshe {
                display: flex;
                justify-content: center;
                align-items: center;
              }

              &.goodsBo {
                display: flex;
                justify-content: center;
                align-items: center;
                flex-wrap: wrap;
                line-height: 1;

                .eu {
                  font-size: 16px;
                  font-weight: 600;
                }
              }

              .mingXi {
                display: block;
                font-size: 12px;
                text-align: center;
                color: #667085;
                line-height: 16px;
                cursor: pointer;
              }
            }

            // 数量单元格样式
            &.goodsNumber {
              display: flex;
              justify-content: center;
              align-items: center;
              flex: 0 0 150px;

              &.goodsBo {
                font-size: 12px;
                font-weight: 400;
                line-height: 12px;
                text-align: center;
              }
            }

            // 商铺单元格样式
            &.goodsName {
              display: flex;

              /deep/.el-image {
                $imgSize: 55px;
                width: $imgSize;
                height: $imgSize;
                transition: 0.3s;
                text-align: center;

                i {
                  font-size: $imgSize/4;
                  line-height: $imgSize;
                }
              }

              .goodsTitle {
                padding: 0 30px;
                padding-top: 4px;
                height: 55px;
                font-size: 12px;
                font-weight: 400;
                position: relative;
                top: -5px;
                color: #101828;
                line-height: 22px;
                text-overflow: -o-ellipsis-lastline;
                overflow: hidden;
                text-overflow: ellipsis;
                display: -webkit-box;
                -webkit-line-clamp: 2;
                -webkit-box-orient: vertical;
              }
            }
          }
        }
      }

      .showAllRow {
        height: 48px;
        background: #fafafa;
        border-top: 1px solid #eaecf0;
        box-shadow: none;
        border-radius: 0 0 12px 12px;
        position: sticky;
        bottom: 0;
        width: 100%;
        left: 0;
        margin-top: 24px;
        display: flex;
        justify-content: flex-end;
        align-items: center;

        .jiahao {
          width: 24px;
          height: 24px;
          margin-right: 32px;
          cursor: pointer;
        }
      }

      &.GoodsArrAll {
        // min-height: 392px;
        max-height: unset !important;
      }
    }
  }

  .ortherBox {
    margin-left: 40px;

    .operatingPrinciple {
      padding: 32px 28px 28px;
      margin-bottom: 20px;
      width: 560px;
      max-width: 100%;
      background: #ffffff;
      border: 1px solid #eaecf0;
      border-radius: 12px;
      box-shadow: 0 1px 3px rgba(16, 24, 40, 0.06);
      box-sizing: border-box;

      .operatingPrincipletishi {
        margin-bottom: 16px;
        font-size: 18px;
        font-weight: 600;
        color: #101828;
        line-height: 26px;
        font-family: "Open Sans", Sans-serif;
      }

      .tishiOpt {
        min-height: 100px;
        border-bottom: solid 1px #eaecf0;
        display: flex;
        align-items: flex-start;
        padding: 30px 0;

        &:last-of-type {
          border-bottom: none;
        }

        .tihsiNum {
          flex: 0 0 41px;
          height: 41px;
          background: #f9fafb;
          border: 1px solid #eaecf0;
          border-radius: 50%;
          display: flex;
          justify-content: center;
          align-items: center;
          margin-right: 20px;
        }

        .tishiCon {
          h1 {
            font-size: 16px;
            font-family: "Open Sans", Sans-serif;
            font-weight: 600;
            color: #101828;
            line-height: 22px;
            margin-bottom: 8px;
          }

          > div {
            min-height: 35px;
            font-size: 14px;
            font-family: "Open Sans", Sans-serif;
            font-weight: 400;
            line-height: 21px;
            color: #475467;
          }
        }
      }
    }

    .contactUs {
      width: 560px;
      max-width: 100%;
      background: #ffffff;
      border: 1px solid #eaecf0;
      border-radius: 12px;
      padding: 32px 28px;
      box-shadow: 0 1px 3px rgba(16, 24, 40, 0.06);
      box-sizing: border-box;

      h1 {
        font-size: 18px;
        font-weight: 600;
        color: #101828;
        line-height: 26px;
        margin-bottom: 20px;
      }

      p {
        width: 100%;
        max-width: 505px;
        min-height: 74px;
        background: #ffffff;
        border: 1px solid #eaecf0;
        border-radius: 12px;
        margin-bottom: 10px;
        display: flex;
        align-items: center;
        padding: 0 10px 0 20px;
        cursor: pointer;
        box-sizing: border-box;

        &:hover {
          background-color: #f9fafb;
        }

        img {
          width: 18px;
          margin-right: 9px;
        }

        span {
          font-size: 16px;
          line-height: 22px;
          color: #344054;

          .blueFont {
            color: #009246;
            font-weight: 600;
          }
        }

        a {
          display: flex;
          align-items: center;
        }

        .jiantou {
          margin-left: auto;
          width: 8px;
        }
      }
    }
  }
}

.recommendGoodsMain {
  width: 100%;
  max-width: $pageWidth;
  margin: 0 auto 40px;
  box-sizing: border-box;

  nav {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 16px;

    h4 {
      font-size: 22px;
      font-weight: 600;
      color: #101828;
    }

    .iconBox {
      img {
        width: 40.88px;
        height: 40.88px;

        &:last-child {
          margin-left: 16px;
          margin-right: 8px;
        }

        opacity: 0.45;

        &:hover {
          opacity: 0.75;
        }
      }
    }
  }

  .recommendGoodsBox {
    display: flex;
    justify-content: space-between;
    .recommendGoods {
      cursor: pointer;
      width: 213.31px;
      padding: 15px;
      height: 290px;
      background-color: #ffffff;
      border: 1px solid #eaecf0;
      border-radius: 12px;
      margin: 6px 2px;
      transition: 0.3s;
      box-sizing: border-box;

      .imageBox {
        width: 100%;
        height: 187.31px;
        margin-bottom: 5px;
        text-align: center;

        /deep/.el-image {
          $imgSize: 181.31px;
          width: $imgSize;
          height: $imgSize;
          transition: 0.3s;
          text-align: center;

          i {
            font-size: $imgSize/4;
            line-height: $imgSize;
          }
        }
      }

      .goodsTitle {
        height: 39px;

        text-overflow: -o-ellipsis-lastline;
        overflow: hidden;
        text-overflow: ellipsis;
        line-height: 1.5;
        display: -webkit-box;
        -webkit-line-clamp: 2;
        -webkit-box-orient: vertical;
        margin-bottom: 5px;
        color: #344054;
        font-family: "Open Sans", Sans-serif;
        font-size: 13px;
        font-weight: 500;
      }

      .priceBox {
        color: #ffa200;
        font-size: 15px;
        font-weight: 500;
        line-height: 1.6em;
      }

      &:hover {
        transform: translateY(-4px);
        box-shadow: 0 4px 12px rgba(16, 24, 40, 0.08);
      }
    }
  }
}

/deep/.el-carousel__arrow--right,
/deep/.el-carousel__arrow--left {
  display: none;
  width: 100px;
  height: 100px;
  background: #ffffff;
  opacity: 0.6;
  border-radius: 50%;
}

/deep/ .el-carousel__arrow {
  background: rgba(255, 255, 255, 0.5);

  i {
    color: $homePageSubjectColor;
    font-size: 60px;
    font-weight: 700;
  }
}

/deep/.el-carousel__button {
  display: none;
  width: 12px;
  height: 12px;
  background: #ffffff;
  border-radius: 50%;
}

/deep/.el-carousel__indicator.el-carousel__indicator--horizontal.is-active
  .el-carousel__button {
  outline: 3px solid $homePageSubjectColor;
  background-color: transparent;
}
</style>
